var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:""},[_c('div',{staticClass:"border-gray-300 border"},[_c('div',{staticClass:"p-2 m-1 h3",on:{"click":_vm.zoomin}},[_vm._v("+")]),_vm._v(" "),_c('div',{staticClass:"p-1 pt-0 m-0 m-0 h3",on:{"click":_vm.zoomout}},[_vm._v("-")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }